import { apiClient } from "./apiClient";

export async function fetchContactSearch({ queryKey }) {
    const [_key, query] = queryKey;
    const response = await apiClient(`/api/agent/contact_search/?search=${encodeURIComponent(query)}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}
